export const LOGROCKET_DASHBOARD_ID = 'abqepz/fisherman-dashboard';

export const USER_PRIVATE_DATA = '<USER_PRIVATE_DATA>';
